import { index, pgEnum, pgTable, text, unique, uuid } from "drizzle-orm/pg-core";
import { catalogItems } from "./catalog-item";

export const externalIdSystemEnum = pgEnum("external_id_system", [
  "ROCA",
  "TCGPLAYER",
  "STOCKX",
  "FANATICS",
  /** A Shopify product variant GID. */
  "SHOPIFY",
  "OTHER",
]);

/**
 * A vendor system's own id for one catalog item. Supporting vendor listings later means
 * an additional nullable vendor_listing_id plus a check constraint, not built now.
 * Indexed by item too: Boxed asks for an item's ids on every catalog id read.
 */
export const externalProductIds = pgTable(
  "external_product_ids",
  {
    catalogItemId: uuid("catalog_item_id")
      .notNull()
      .references(() => catalogItems.id),
    system: externalIdSystemEnum("system").notNull(),
    value: text("value").notNull(),
  },
  (t) => [
    unique().on(t.system, t.value),
    index("external_product_ids_catalog_item_idx").on(t.catalogItemId),
  ],
);
